import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  setAccountSecurityPolicy(params) {
    return axios.post(`${baseUrl}/settings/account-policy/set-account-policy.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/user/account-security-policy.js